module.exports = __webpack_public_path__ + "img/search-icon.35c3fa00.svg";